import { mapMutations } from 'vuex'
import * as dd from 'dingtalk-jsapi'

const myVuex = {
  methods: {
    getCode (callback) {
      // 微应用免登用户所在企业应用的corpId
      // eslint-disable-next-line no-undef
      const corpId = GlobUrl.corpId
      console.log('执行', dd.env)
      if (dd.env.platform !== 'notInDingTalk') {
        dd.ready(() => {
          // 使用SDK 获取免登授权码
          dd.runtime.permission.requestAuthCode({
            corpId: corpId,
            onSuccess: (info) => {
              // 根据钉钉提供的api 获得code后,再次调用这个callback方法
              // 由于是钉钉获取code是异步操作,不知道什么时候执行完毕
              // callback 函数会等他执行完毕后在自己调用自己
              callback(info.code)
            },
            onFail: (err) => {
              alert(JSON.stringify(err))
            }
          })
        })
      }
    },
    saveLoginData (data) {
      this.setToken(data.token)
      this.setExpireTime(data.expireTime)
      this.setUser(data.user)
      this.setPermissions(data.permissions)
      this.setRoles(data.roles)
      this.setTheme(data.config.theme)
      this.setLayout(data.config.layout)
      this.setMultipage(data.config.multiPage === '1')
      this.fixSiderbar(data.config.fixSiderbar === '1')
      this.fixHeader(data.config.fixHeader === '1')
      this.setColor(data.config.color)
    },
    ...mapMutations({
      setToken: 'account/setToken',
      setExpireTime: 'account/setExpireTime',
      setPermissions: 'account/setPermissions',
      setRoles: 'account/setRoles',
      setUser: 'account/setUser',
      setTheme: 'setting/setTheme',
      setLayout: 'setting/setLayout',
      setMultipage: 'setting/setMultipage',
      fixSiderbar: 'setting/fixSiderbar',
      fixHeader: 'setting/fixHeader',
      setColor: 'setting/setColor'
    })
  }
}
export default myVuex



// WEBPACK FOOTER //
// ./src/views/ddLogin/myData.js